<app-dialog-close-button class="close-button" [compact]="true" (closed)="close()"></app-dialog-close-button>
 <h2 vng-dialog-title class="text-center">
    Would you like to pause your billing for 1-month instead?
 </h2>

<div class="text-center mb-small">
    While your billing is paused, you will not lose any of your FlyMSGs.
</div>

 <vng-dialog-actions align="center" class="top-space mb-small" style="display:flex; justify-content:center; align-items:center; gap:15px">
    <!--HubSpot Call-to-Action Code -->
    <span class="hs-cta-wrapper" id="hs-cta-wrapper-13d73c76-9a67-40cc-ae76-4f21efe440b4" *ngIf="isStarterPlan()">
        <span class="hs-cta-node hs-cta-13d73c76-9a67-40cc-ae76-4f21efe440b4" id="hs-cta-13d73c76-9a67-40cc-ae76-4f21efe440b4">
            <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
            <button id="hs-cta-img-13d73c76-9a67-40cc-ae76-4f21efe440b4" (click)="pausePlan()" vng-button variant="primary">
                Pause for 1-Month
            </button>
        </span>
    </span>

    <span class="hs-cta-wrapper" id="hs-cta-wrapper-4387c0a1-6137-430f-9bc1-26f9eaf7b598" *ngIf="isGrowthPlan()">
        <span class="hs-cta-node hs-cta-4387c0a1-6137-430f-9bc1-26f9eaf7b598" id="hs-cta-4387c0a1-6137-430f-9bc1-26f9eaf7b598">
            <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
            <button id="hs-cta-img-4387c0a1-6137-430f-9bc1-26f9eaf7b598" (click)="pausePlan()" vng-button variant="primary">
                Pause for 1-Month
            </button>
        </span>
    </span>
    <!-- end HubSpot Call-to-Action Code -->
   <!-- V3-04: orange outline variant, matching downgrade-plan-one and master. -->
   <button (click)="downgradePlan()" vng-button variant="outline">
       {{isGrowthPlan() ? 'Downgrade My Plan' : 'Downgrade to Freemium'}}
    </button>
 </vng-dialog-actions>
